import { render, staticRenderFns } from "./ClinicInvoice.vue?vue&type=template&id=c9e1d7a4"
import script from "./ClinicInvoice.vue?vue&type=script&lang=js"
export * from "./ClinicInvoice.vue?vue&type=script&lang=js"
import style0 from "./ClinicInvoice.vue?vue&type=style&index=0&id=c9e1d7a4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports